import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { SelectionCard } from 'components/SelectionCard/SelectionCard';
import styles from '../CurrentPlatformStep.scss';
import { useAppStore } from 'stores/state';
import { EcommercePlatform } from 'config/enums';
import { currentPlatformItemProps } from 'config/maps';

export const CurrentPlatformStepOptions: FC = () => {
  const { t } = useTranslation();

  const currentPlatform = useAppStore((state) => state.currentPlatform);
  const setCurrentPlatform = useAppStore((state) => state.setCurrentPlatform);

  const handleSelectCurrentPlatform = (platform: EcommercePlatform) => {
    setCurrentPlatform(platform);
  };

  return (
    <div className={styles.currentPlatformStepOptions}>
      {Object.values(EcommercePlatform).map((platform) => {
        const Icon = currentPlatformItemProps[platform].icon;
        return (
          <SelectionCard
            title={t(`current-platform-step.options.item.title.${platform}`)}
            onClick={() => handleSelectCurrentPlatform(platform)}
            isSelected={currentPlatform === platform}
            icon={<Icon />}
            key={platform}
          />
        );
      })}
    </div>
  );
};
